import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';
import { accountActions, modalActions, chartsActions, futureIncomeAndExpensesActions, eventActions } from '../../../redux/root-action';
import { analyticsTracking, postActions } from '../../../utils/constants';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import IncomeExpensesCard from './IncomeExpensesCard';
import { keyDown } from '../../../utils/helpers';
import { eventModalViews, modals, derivedAttributes } from '../../../utils/constants';
import ToggleSection from '../Account/ToggleSection';

const TileSubheader = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
  padding-bottom: 16px;
  padding-top: 16px;
  letter-spacing: 0.4px;
  margin-bottom: 24px;
`;

const StyledBorder = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid #73d5ff;
  margin-bottom: 0px;
  color: ${tokens.ColorGrey700};
`;

const SubHeadLeft = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
`;
const SubHeadRight = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
  float: right;
`;

const IncomeExpensesLayout = styled.div`
  background-color: ${tokens.ColorWhite025};
  margin-top: 24px;
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 16px;
    margin: 24px 0px 8px 0px;
  }
`;

const IncomeExpensesHeader = styled.div`
  flex: 170px 0 0;
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 22px;
  padding-top: 5px;
  color: ${tokens.ColorGrey800};
`;

const IncomeExpensesHeaderButtonContainer = styled.div`
  display: flex;
`;

const EventRow = styled.div`
  display: flex;
  &:not(:last-of-type) {
    border-bottom: 1px solid ${tokens.ColorWhite100};
  }
`;

const HeaderStyle = styled.div`
  margin-top: 24px;
`;

interface MyState {
  checkToggle: boolean
}
class FutureIncomeModal extends Component<any, MyState> {
  props: any;
  state: any;

  constructor(props: any) {
    super(props);
    this.state = {
      futureIncludeFlag: true,
      expensesIncludeFlag: true,
      checkToggle: false,
      originalRiScenario: JSON.parse(JSON.stringify(props?.riScenario?.events)),
    };
  }

  cleanUpObjects = (objArr: Array<Record<any, any>>) => {
    return objArr.map((obj: Record<any, any>) => {
      let cleanedObject = {};
      Object.keys(obj).forEach(key => {
        if (!derivedAttributes.includes(key)) {
          cleanedObject = { ...cleanedObject, [key]: obj[key] };
        }
      });
      return cleanedObject;
    });
  };

  showSelectedEventInforation = (event: any) => {
    const { setSelectedEvent, setCurrentView, showModal } = this.props;
    setSelectedEvent({
      ...event,
    });

    showModal(eventModalViews.ADD_FUTURE_INCOME);
    setCurrentView(eventModalViews.ADD_FUTURE_INCOME);
  };

  showSelectedExpenseEventInforation = (event: any) => {
    const { setSelectedEvent, setCurrentView, showModal } = this.props;
    setSelectedEvent({
      ...event,
    });

    showModal(eventModalViews.ADD_FUTURE_EXPENSE);
    setCurrentView(eventModalViews.ADD_FUTURE_EXPENSE);
  }

  handleDone = () => {
    const {
      hideModal,
      postSimulation,
      riScenario,
      updateEventsData,
      modelIncomeEventsData,
      updateFutureIncludeInScenario,
      // events,
      selectedEvent,
      tempScenario: { events },
      riScenario: { scenarioId, participantProfile, spouseProfile, retirementStartAge, retirementEndAge },
      accHolder,
    } = this.props;

    const tempEvents = [...events];
    const {
      eventIndex,
      action,
      name,
      typeName,
      categoryName,
      amount,
      sourceValue,
      startNumber,
      endNumber,
      endAge,
      asOfDate,
      sameAsRetirementAge,
      unit,
      frequency,
      accountKey,
      includeInScenario,
      id,
      accountHolder
    } = selectedEvent;

    tempEvents[eventIndex] = {
      ...selectedEvent,
      id,
      bpId: accountHolder === accHolder ? participantProfile?.bpId : spouseProfile?.bpId,
      action: action ? action : postActions.UPDATE,
      scenarioId,
      name,
      typeName,
      amount,
      includeInScenario: includeInScenario,
      startNumber,
      endNumber: endNumber !== undefined ? endNumber : null,
      accountKey,
      accountHolder,
      frequency,
      unit: 'AGE',
      categoryName,
      sameAsRetirementAge: startNumber === retirementStartAge && endNumber === retirementEndAge ? 'Yes' : 'No',
    };
    
    modelIncomeEventsData({ events: tempEvents });

    let eventEntry = events?.reduce(
      (accum: number, event: any) => accum + (event.includeInScenario && event.action !== 'DELETE' ? 1 : 0), 0
    );
    const totalEventEntries = events?.reduce(
      (accum: number, event: any) => accum + (event.action !== 'DELETE' ? 1 : 0), 0
    );
    if (eventEntry > 0) {
      document.querySelector('#future-income-expenses-input-tile-value')!.innerHTML = eventEntry + ` of ` + totalEventEntries + ` Entries`;
    } else {
      document.querySelector('#future-income-expenses-input-tile-value')!.innerHTML = eventEntry + ` Entries`;
    }
    document.getElementsByTagName('html')[0].classList.remove('fixed');
    document.getElementsByTagName('html')[0].removeAttribute('style');

    hideModal();
  };

  handleCancel = () => {
    const {
      hideModal,
      updateEventsData,
      selectedEvent,
      riScenario: { events },
    } = this.props;
    
    // cancel should not modify the data that was retrieved from the API call
    // updateEventsData({ events: this.state.originalRiScenario ? this.state.originalRiScenario : [] });
    hideModal();
  };

  updateFutureIncludeExcludeToggle = (id: number, name: string) => {
    const { updateFutureIncludeInScenario, events } = this.props;
    const tempEvents = [...events];

    for (const event of tempEvents) {
      if (event.name === name && event.id === id) {
        event.includeInScenario = !event.includeInScenario;
        event.action = 'UPDATE'
        this.setState(prevState => ({
          checkToggle: !prevState.checkToggle
        }));
        return updateFutureIncludeInScenario({ events: tempEvents })
      }
    }
  };

  showAddExpenseModal = () => {
    const {
      showModal,
      updateEventsData,
      setCurrentView,
      setSelectedEvent,
      events,
      event,
      selectedEvent,
      // events: { selectedEvent, tempScenario },
      riScenario: { participantProfile },
      accHolder
    } = this.props;

    const newEvent = {
      eventIndex: events?.length,
      // name: selectedEvent.name,
      accountHolder: accHolder ? accHolder : `${participantProfile?.firstName} ${participantProfile?.lastName}`,
      action: postActions.ADD,
      isNewEvent: true,
      // annualAmount: selectedEvent.annualAmount,
      // startAge: selectedEvent.startAge,
      // endAge: selectedEvent.endAge,
      // includeInScenario: true,
      categoryName: 'Expense',
    };
    // console.log(this.props);
    // const tempEvents = [...events];
    const tempEvents = [...events];
    tempEvents.push(newEvent);
    updateEventsData({ events: tempEvents });
    setSelectedEvent(newEvent);
    setCurrentView(eventModalViews.ADD_FUTURE_EXPENSE)
    showModal(eventModalViews.ADD_FUTURE_EXPENSE);
  }

  showAddIncomeModal = () => {
    const {
      showModal,
      updateEventsData,
      setCurrentView,
      setSelectedEvent,
      events,
      event,
      selectedEvent,
      // events: { selectedEvent, tempScenario },
      riScenario: { participantProfile },
      accHolder
    } = this.props;

    const newEvent = {
      eventIndex: events?.length,
      // name: selectedEvent.name,
      accountHolder: accHolder ? accHolder : `${participantProfile?.firstName} ${participantProfile?.lastName}`,
      action: postActions.ADD,
      isNewEvent: true,
      // annualAmount: selectedEvent.annualAmount,
      // startAge: selectedEvent.startAge,
      // endAge: selectedEvent.endAge,
      // includeInScenario: true,
      categoryName: 'Income',
    };
    
    const tempEvents = [...events];
    tempEvents.push(newEvent);
    updateEventsData({ events: tempEvents });
    setSelectedEvent(newEvent);
    setCurrentView(eventModalViews.ADD_FUTURE_INCOME)
    //const tempEvents = [...events];
    // tempEvents.push(newEvent);
    // updateEventsData({ events: tempEvents });
    // setSelectedEvent(newEvent);
    showModal(eventModalViews.ADD_FUTURE_INCOME);
    //setCurrentView(eventModalViews.ADD_FUTURE_INCOME)
  }

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    const { riScenario, events, accHolder } = this.props;

    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Future Income and Expenses'} showClose={true} handleCloseIconClick={this.handleCancel}
        />
        <ReactModalContent>
          <TileSubheader>
            Future income and expense entries are payments you expect to receive or make during retirement. Estimating
            them may give you a more accurate projection of your retirement income and savings balance over time. Once
            added, you can manually exclude income and expense entries from your projections.
          </TileSubheader>
          {this.state.futureIncludeFlag && <SubHeadRight>Included</SubHeadRight>}
          <SubHeadLeft>Future Income</SubHeadLeft>
          <StyledBorder />
          <div>
            {events?.map(
              (event: any, index: number) => (
                <>
                  {(event.categoryName === 'Income' || event.categoryName === 'Pension') && event.action !== 'DELETE' && (
                    <EventRow>
                      <IncomeExpensesCard
                        key={index}
                        page="futureIncomeAndExpenses"
                        disabled={event.includeInScenario ? false : true}
                        data={{ ...event }}
                        accHolder={accHolder}
                        id={'futureIncomeExpense'}
                        onClick={() => this.showSelectedEventInforation(event)}
                      />
                      <ToggleSection
                        isOn={event.includeInScenario}
                        id={'future-income-toggle' + index}
                        handleIncludeExclude={() => this.updateFutureIncludeExcludeToggle(event.id, event.name)}
                      />
                    </EventRow>
                  )}
                </>
              ))}
          </div>
          <IncomeExpensesLayout>
            <IncomeExpensesHeader> Add inheritance, retirement job, etc.</IncomeExpensesHeader>
            <IncomeExpensesHeaderButtonContainer>
              <Button
                type="secondary"
                title="Add Income"
                tabIndex={0}
                onClick={this.showAddIncomeModal}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showAddIncomeModal)}
                id={analyticsTracking.RIXFutureIncomeandExpensesModalAddIncome}
              />
            </IncomeExpensesHeaderButtonContainer>
          </IncomeExpensesLayout>
          <HeaderStyle>
            {this.state.expensesIncludeFlag && <SubHeadRight>Included</SubHeadRight>}
            <SubHeadLeft>Future Expenses</SubHeadLeft>
          </HeaderStyle>

          <StyledBorder />
          <div>
            {events?.map((event: any, index: number) => (
              <>
                {event.categoryName === 'Expense' && event.action !== 'DELETE' && (
                  <EventRow>
                    <IncomeExpensesCard
                      key={index}
                      page={event.page}
                      disabled={event.includeInScenario ? false : true}
                      data={{ ...event }}
                      accHolder={accHolder}
                      onClick={() => this.showSelectedExpenseEventInforation(event)}
                    />
                    <ToggleSection
                      isOn={event.includeInScenario}
                      id={'strategy-balance-workplace-account-toggle' + index}
                      handleIncludeExclude={() => this.updateFutureIncludeExcludeToggle(event.id, event.name)} />
                  </EventRow>
                )}
              </>
            ))}
          </div>
          <IncomeExpensesLayout>
            <IncomeExpensesHeader> Add healthcare, financial gifts, etc.</IncomeExpensesHeader>
            <IncomeExpensesHeaderButtonContainer>
              <Button
                type="secondary"
                title="Add Expense"
                tabIndex={0}
                onClick={this.showAddExpenseModal}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showAddExpenseModal)}
                id={analyticsTracking.RIXFutureIncomeandExpensesModalAddExpense}
              />
            </IncomeExpensesHeaderButtonContainer>
          </IncomeExpensesLayout>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Done"
          handleCTAClick={this.handleDone}
          hideCancel={true}
          CTAButtonId={analyticsTracking.RIXFutureIncomeandExpensesModalActionDone}
        >
          <Button
            type="secondary"
            title="Cancel"
            fitContainerWidth={mq.matches ? true : false}
            marginRightPx={mq.matches ? 0 : 16}
            onClick={this.handleCancel}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleCancel)}
            id={analyticsTracking.RIXFutureIncomeandExpensesModalActionCancel}
          />
        </ReactModalFooter>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  events: { currentPage, modelledScenario, tempScenario, selectedEvent },
  riScenario,
  charts
}: any) => ({
  events: tempScenario?.events,
  tempScenario,
  riScenario,
  currentPage,
  modelledScenario,
  selectedEvent,
  updatedEvents: tempScenario.events?.filter((event: any) => event.action),
  accHolder: riScenario?.participantProfile?.firstName + ' ' + riScenario?.participantProfile?.lastName,
  isLoading: riScenario.loading || charts.loading
});

export default connect(mapStateToProps, {
  setCurrentView: eventActions.setCurrentView,
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  postSimulation: chartsActions.postSimulation,
  updateEventsData: eventActions.updateIncomeEventData,
  setSelectedEvent: eventActions.setSelectedIncomeEvent,
  modelIncomeEventsData: eventActions.modelIncomeEventsData,
  updateFutureIncludeInScenario: futureIncomeAndExpensesActions.updateFutureIncludeInScenario,
  modelFutureIncludeInScenario: futureIncomeAndExpensesActions.modelFutureIncludeInScenario,
  setInitialFutureIncludeInScenario: futureIncomeAndExpensesActions.setInitialFutureIncludeInScenario
})(FutureIncomeModal);
